export const PERMISSION = {
  // Dashboard
  DASHBOARD: {
    NAME: 'Dashboard',
    ALL: 'dashboard',
    SCREEN: 'dashboard.read.screen',
    GET: 'dashboard.read.get',
  },

  // Insurance Company
  INSURANCE_COMPANY: {
    NAME: 'InsuranceCompany',
    ALL: 'insurance-company',
    SCREEN: 'insurance-company.read.screen',
    LIST: 'insurance-company.read.list',
    GET: 'insurance-company.read.get',
    CREATE: 'insurance-company.write.create',
    UPDATE: 'insurance-company.write.update',
    DELETE: 'insurance-company.write.delete',
    ERP_LIST: 'insurance-company.write.erp-list',
    ERP_UPDATE: 'insurance-company.write.erp-update',
  },

  // Provider
  PROVIDER: {
    NAME: 'Provider',
    ALL: 'provider',
    SCREEN: 'provider.read.screen',
    LIST: 'provider.read.list',
    GET: 'provider.read.get',
    CREATE: 'provider.write.create',
    UPDATE: 'provider.write.update',
    DELETE: 'provider.write.delete',
    DOWNLOAD: 'provider.write.download',
    ERP_LIST: 'provider.write.erp-list',
    ERP_UPDATE: 'provider.write.erp-update',
  },

  // Beneficiary
  BENEFICIARY: {
    NAME: 'Beneficiary',
    ALL: 'beneficiary',
    SCREEN: 'beneficiary.read.screen',
    LIST: 'beneficiary.read.list',
    GET: 'beneficiary.read.get',
    CREATE: 'beneficiary.write.create',
    UPDATE: 'beneficiary.write.update',
    DELETE: 'beneficiary.write.delete',
    ERP_LIST: 'beneficiary.write.erp-list',
    ERP_UPDATE: 'beneficiary.write.erp-update',
  },

  // Contract
  CONTRACT: {
    NAME: 'Contract',
    ALL: 'contract',
    SCREEN: 'contract.read.screen',
    LIST: 'contract.read.list',
    GET: 'contract.read.get',
    CREATE: 'contract.write.create',
    UPDATE: 'contract.write.update',
    DELETE: 'contract.write.delete',
    ERP_LIST: 'contract.write.erp-list',
    ERP_UPDATE: 'contract.write.erp-update'
  },

  // Policy
  POLICY: {
    NAME: 'Policy',
    ALL: 'policy',
    SCREEN: 'policy.read.screen',
    LIST: 'policy.read.list',
    GET: 'policy.read.get',
    CREATE: 'policy.write.create',
    UPDATE: 'policy.write.update',
    DELETE: 'policy.write.delete',
    DOWNLOAD: 'policy.write.download',
    EMAIL: 'policy.write.email',
    ERP_LIST: 'policy.write.erp-list',
    ERP_UPDATE: 'policy.write.erp-update',
  },

  // Service Type
  SERVICE_TYPE: {
    NAME: 'ServiceType',
    ALL: 'service-type',
    SCREEN: 'service-type.read.screen',
    LIST: 'service-type.read.list',
    GET: 'service-type.read.get',
    CREATE: 'service-type.write.create',
    UPDATE: 'service-type.write.update',
    DELETE: 'service-type.write.delete',
  },

  // Service Code
  SERVICE_CODE: {
    NAME: 'ServiceCode',
    ALL: 'service-code',
    SCREEN: 'service-code.read.screen',
    LIST: 'service-code.read.list',
    GET: 'service-code.read.get',
    CREATE: 'service-code.write.create',
    UPDATE: 'service-code.write.update',
    DELETE: 'service-code.write.delete',
  },

  // Network
  NETWORK: {
    NAME: 'Network',
    ALL: 'network',
    SCREEN: 'network.read.screen',
    LIST: 'network.read.list',
    GET: 'network.read.get',
    CREATE: 'network.write.create',
    UPDATE: 'network.write.update',
    DELETE: 'network.write.delete',
    ERP_LIST: 'network.write.erp-list',
    ERP_UPDATE: 'network.write.erp-update',
  },

  // Common LOV
  COMMON_LOV: {
    NAME: 'CommonLov',
    ALL: 'common-lov',
    SCREEN: 'common-lov.read.screen',
    LIST: 'common-lov.read.list',
    GET: 'common-lov.read.get',
    CREATE: 'common-lov.write.create',
    UPDATE: 'common-lov.write.update',
    DELETE: 'common-lov.write.delete',
  },

  // Medical Device
  MEDICAL_DEVICE: {
    NAME: 'MedicalDevice',
    ALL: 'medical-device',
    SCREEN: 'medical-device.read.screen',
    LIST: 'medical-device.read.list',
    GET: 'medical-device.read.get',
    CREATE: 'medical-device.write.create',
    UPDATE: 'medical-device.write.update',
    DELETE: 'medical-device.write.delete',
  },

  // Master Data
  MASTER_DATA: {
    NAME: 'MasterData',
    ALL: 'master-data',
    SCREEN: 'master-data.read.screen',
    LIST: 'master-data.read.list',
    GET: 'master-data.read.get',
    CREATE: 'master-data.write.create',
    UPDATE: 'master-data.write.update',
    DELETE: 'master-data.write.delete',
    JSON: 'master-data.read.jsonfile'
  },

  // Policy Class
  POLICY_CLASS: {
    NAME: 'PolicyClass',
    ALL: 'policy-class',
    SCREEN: 'policy-class.read.screen',
    LIST: 'policy-class.read.list',
    GET: 'policy-class.read.get',
    CREATE: 'policy-class.write.create',
    UPDATE: 'policy-class.write.update',
    DELETE: 'policy-class.write.delete',
    ERP_LIST: 'policy-class.write.erp-list',
    ERP_UPDATE: 'policy-class.write.erp-update',
  },

  // Benefit
  BENEFIT: {
    NAME: 'Benefit',
    ALL: 'benefit',
    SCREEN: 'benefit.read.screen',
    LIST: 'benefit.read.list',
    GET: 'benefit.read.get',
    CREATE: 'benefit.write.create',
    UPDATE: 'benefit.write.update',
    DELETE: 'benefit.write.delete',
    ERP_LIST: 'benefit.write.erp-list',
    ERP_UPDATE: 'benefit.write.erp-update',
  },

  // Diagnosis Code
  DIAGNOSIS_CODE: {
    NAME: 'DiagnosisCode',
    ALL: 'diagnosis-code',
    SCREEN: 'diagnosis-code.read.screen',
    LIST: 'diagnosis-code.read.list',
    GET: 'diagnosis-code.read.get',
    CREATE: 'diagnosis-code.write.create',
    UPDATE: 'diagnosis-code.write.update',
    DELETE: 'diagnosis-code.write.delete',
  },

  // Speciality
  SPECIALITY: {
    NAME: 'Specialty',
    ALL: 'speciality',
    SCREEN: 'speciality.read.screen',
    LIST: 'speciality.read.list',
    GET: 'speciality.read.get',
    CREATE: 'speciality.write.create',
    UPDATE: 'speciality.write.update',
    DELETE: 'speciality.write.delete',
  },

  // Price List
  PRICE_LIST: {
    NAME: 'PriceList',
    ALL: 'pricelist',
    SCREEN: 'pricelist.read.screen',
    LIST: 'pricelist.read.list',
    GET: 'pricelist.read.get',
    CREATE: 'pricelist.write.create',
    UPDATE: 'pricelist.write.update',
    DELETE: 'pricelist.write.delete',
    ERP_LIST: 'pricelist.write.erp-list',
    ERP_UPDATE: 'pricelist.write.erp-update',
  },

  // LOINC Code
  LOINC_CODE: {
    NAME: 'LoincCode',
    ALL: 'loinc-code',
    SCREEN: 'loinc-code.read.screen',
    LIST: 'loinc-code.read.list',
    GET: 'loinc-code.read.get',
    CREATE: 'loinc-code.write.create',
    UPDATE: 'loinc-code.write.update',
    DELETE: 'loinc-code.write.delete',
  },

  // Physician
  PHYSICIAN: {
    NAME: 'Physician',
    ALL: 'physician',
    SCREEN: 'physician.read.screen',
    LIST: 'physician.read.list',
    GET: 'physician.read.get',
    CREATE: 'physician.write.create',
    UPDATE: 'physician.write.update',
    DELETE: 'physician.write.delete',
  },

  // Claim Type
  CLAIM_TYPE: {
    NAME: 'ClaimType',
    ALL: 'claim-type',
    SCREEN: 'claim-type.read.screen',
    LIST: 'claim-type.read.list',
    GET: 'claim-type.read.get',
    CREATE: 'claim-type.write.create',
    UPDATE: 'claim-type.write.update',
    DELETE: 'claim-type.write.delete',
  },

  // Body Sub Site
  BODY_SUB_SITE: {
    NAME: 'BodySubSite',
    ALL: 'body-sub-site',
    SCREEN: 'body-sub-site.read.screen',
    LIST: 'body-sub-site.read.list',
    GET: 'body-sub-site.read.get',
    CREATE: 'body-sub-site.write.create',
    UPDATE: 'body-sub-site.write.update',
    DELETE: 'body-sub-site.write.delete',
  },

  // Body Site
  BODY_SITE: {
    NAME: 'BodySite',
    ALL: 'body-site',
    SCREEN: 'body-site.read.screen',
    LIST: 'body-site.read.list',
    GET: 'body-site.read.get',
    CREATE: 'body-site.write.create',
    UPDATE: 'body-site.write.update',
    DELETE: 'body-site.write.delete',
  },

  //Encounter
  ENCOUNTER_CLASS: {
    NAME: 'EncounterClass',
    ALL: 'encounter-class',
    SCREEN: 'encounter-class.read.screen',
    LIST: 'encounter-class.read.list',
    GET: 'encounter-class.read.get',
    CREATE: 'encounter-class.write.create',
    UPDATE: 'encounter-class.write.update',
    DELETE: 'encounter-class.write.delete'
  },

  //Morphology
  MORPHOLOGY: {
    NAME: 'Morphology',
    ALL: 'morphology',
    SCREEN: 'morphology.read.screen',
    LIST: 'morphology.read.list',
    GET: 'morphology.read.get',
    CREATE: 'morphology.write.create',
    UPDATE: 'morphology.write.update',
    DELETE: 'morphology.write.delete'
  },

  // Reason
  REASON: {
    NAME: 'Reason',
    ALL: 'reason',
    SCREEN: 'reason.read.screen',
    LIST: 'reason.read.list',
    GET: 'reason.read.get',
    CREATE: 'reason.write.create',
    UPDATE: 'reason.write.update',
    DELETE: 'reason.write.delete',
  },

  // User
  USER: {
    NAME: 'User',
    ALL: 'user',
    SCREEN: 'user.read.screen',
    LIST: 'user.read.list',
    GET: 'user.read.get',
    CREATE: 'user.write.create',
    UPDATE: 'user.write.update',
    DELETE: 'user.write.delete',
  },

  // Role
  ROLE: {
    NAME: 'Role',
    ALL: 'role',
    SCREEN: 'role.read.screen',
    LIST: 'role.read.list',
    GET: 'role.read.get',
    CREATE: 'role.write.create',
    UPDATE: 'role.write.update',
    DELETE: 'role.write.delete',
  },

  // Permission
  PERMISSION: {
    NAME: 'Permission',
    ALL: 'permission',
    SCREEN: 'permission.read.screen',
    LIST: 'permission.read.list',
    GET: 'permission.read.get',
    CREATE: 'permission.write.create',
    UPDATE: 'permission.write.update',
    DELETE: 'permission.write.delete',
  },

  //Country
  COUNTRY: {
    NAME: 'Country',
    ALL: 'country',
    SCREEN: 'country.read.screen',
    LIST: 'country.read.list',
    GET: 'country.read.get',
    CREATE: 'country.write.create',
    UPDATE: 'country.write.update',
    DELETE: 'country.write.delete',
  },

  //State
  STATE: {
    NAME: 'State',
    ALL: 'state',
    SCREEN: 'state.read.screen',
    LIST: 'state.read.list',
    GET: 'state.read.get',
    CREATE: 'state.write.create',
    UPDATE: 'state.write.update',
    DELETE: 'state.write.delete',
  },

  //City
  CITY: {
    NAME: 'City',
    ALL: 'city',
    SCREEN: 'city.read.screen',
    LIST: 'city.read.list',
    GET: 'city.read.get',
    CREATE: 'city.write.create',
    UPDATE: 'city.write.update',
    DELETE: 'city.write.delete',
  },

  //Category
  CATEGORY: {
    NAME: 'Category',
    ALL: 'category',
    SCREEN: 'category.read.screen',
    LIST: 'category.read.list',
    GET: 'category.read.get',
    CREATE: 'category.write.create',
    UPDATE: 'category.write.update',
    DELETE: 'category.write.delete',
  },

  //Audit Log
  AUDIT_LOG: {
    NAME: 'AuditLog',
    ALL: 'audit-log',
    SCREEN: 'audit-log.read.screen',
    LIST: 'audit-log.read.list',
    GET: 'audit-log.read.get',
    CREATE: 'audit-log.write.create',
    UPDATE: 'audit-log.write.update',
    DELETE: 'audit-log.write.delete',
  },

  //Faq's
  FAQ: {
    NAME: 'Faq',
    ALL: 'faq',
    SCREEN: 'faq.read.screen',
    LIST: 'faq.read.list',
    GET: 'faq.read.get',
    CREATE: 'faq.write.create',
    UPDATE: 'faq.write.update',
    DELETE: 'faq.write.delete',
  },

  //Pre Auth approval
  PRE_AUTH: {
    NAME: 'PreAuth',
    ALL: 'pre-auth',
    SCREEN: 'pre-auth.read.screen',
    LIST: 'pre-auth.read.list',
    GET: 'pre-auth.read.get',
    CREATE: 'pre-auth.write.create',
    UPDATE: 'pre-auth.write.update',
    DELETE: 'pre-auth.write.delete',
    ADJUDICATION: 'pre-auth.write.adjudication',
    HIGHCOST_ADJUDICATION: 'pre-auth.write.highcost-adjudication',
    ASSIGNMENT: 'pre-auth.write.assignment',
    COMMUNICATION: 'pre-auth.write.communication',
    PBM_CREATE: 'pre-auth.write.pbm-create',
    PBM_CANCEL: 'pre-auth.write.pbm-cancel',
    PBM_OVERRIDE: 'pre-auth.write.pbm-override'
  },

  //Claim
  CLAIM: {
    NAME: 'Claim',
    ALL: 'claim',
    SCREEN: 'claim.read.screen',
    LIST: 'claim.read.list',
    GET: 'claim.read.get',
    CREATE: 'claim.write.create',
    UPDATE: 'claim.write.update',
    DELETE: 'claim.write.delete',
    ADJUDICATION: 'claim.write.adjudication',
    ASSIGNMENT: 'claim.write.assignment',
    COMMUNICATION: 'claim.write.communication',
    ACTIVATE: 'claim.write.activate',
    PBM_CREATE: 'claim.write.pbm-create',
    PBM_CANCEL: 'claim.write.pbm-cancel',
    PBM_OVERRIDE: 'claim.write.pbm-override'
  },

  //Claim
  CLAIM_CONVERT: {
    NAME: 'ClaimConvert',
    ALL: 'claim-convert',
    SCREEN: 'claim-convert.read.screen',
    LIST: 'claim-convert.read.list',
    CREATE: 'claim-convert.write.create',
    UPDATE: 'claim-convert.write.update'
  },

  //Uploads
  CLAIM_UPLOADS: {
    NAME: 'ClaimUpload',
    ALL: 'claim-upload',
    SCREEN: 'claim-upload.read.screen',
    LIST: 'claim-upload.read.list',
    GET: 'claim-upload.read.get',
    DELETE: 'claim-upload.write.delete',
    HISTORY: {
      NAME: 'ClaimUploadHistory',
      ALL: 'claim-upload-history',
      SCREEN: 'claim-upload-history.read.screen',
      LIST: 'claim-upload-history.read.list',
      GET: 'claim-upload-history.read.get',
    },
  },

  BATCH: {
    NAME: 'ClaimBatch',
    ALL: 'claim-batch',
    SCREEN: 'claim-batch.read.screen',
    LIST: 'claim-batch.read.list',
    GET: 'claim-batch.read.get',
    CREATE: 'claim-batch.write.create',
    UPDATE: 'claim-batch.write.update',
    DELETE: 'claim-batch.write.delete',
    ASSIGNMENT: 'claim-batch.write.assignment',
    SETTLING: 'claim-batch.write.settling',
    SETTLED: 'claim-batch.write.settled',
    BATCH_DETAILS: {
      NAME: 'ClaimBatchDetail',
      ALL: 'claim-batchdetail',
      CREATE: 'claim-batchdetail.write.create',
      DELETE: 'claim-batchdetail.write.delete'
    }
  },

  PROVIDER_BATCH: {
    NAME: 'ProviderClaimBatch',
    ALL: 'provider-claim-batch',
    SCREEN: 'provider-claim-batch.read.screen',
    LIST: 'provider-claim-batch.read.list',
    GET: 'provider-claim-batch.read.get',
    CREATE: 'provider-claim-batch.write.create',
    UPDATE: 'provider-claim-batch.write.update',
    DELETE: 'provider-claim-batch.write.delete',
    BATCH_DETAILS: {
      NAME: 'ProviderClaimBatchDetail',
      ALL: 'provider-claim-batch-detail',
      CREATE: 'provider-claim-batch-detail.write.create',
      DELETE: 'provider-claim-batch-detail.write.delete'
    }
  },

  //Eligibility
  ELIGIBILITY: {
    NAME: 'Eligibility',
    ALL: 'eligibility',
    SCREEN: 'eligibility.read.screen',
    LIST: 'eligibility.read.list',
    GET: 'eligibility.read.get',
    CREATE: 'eligibility.write.create',
    DELETE: 'eligibility.write.delete',
  },

  //Denial Management
  DENIAL_MANAGEMENT: {
    NAME: 'Denial',
    ALL: 'denial',
    SCREEN: 'denial.read.screen',
    LIST: 'denial.read.list',
    GET: 'denial.read.get',
    UPDATE: 'denial.write.update',
  },

  //Payment
  PAYMENT: {
    NAME: 'Payment',
    ALL: 'payment',
    SCREEN: 'payment.read.screen',
    LIST: 'payment.read.list',
    GET: 'payment.read.get',
    CREATE: 'payment.write.create',
    UPDATE: 'payment.write.update',
    DELETE: 'payment.write.delete',
    DOWNLOAD: 'payment.write.download',
    EMAIL: 'payment.write.email'
  },

  //Payment-Reconciliation
  PAYMENT_RECONCILIATION: {
    NAME: 'PaymentReconciliation',
    ALL: 'payment-reconciliation',
    SCREEN: 'payment-reconciliation.read.screen',
    LIST: 'payment-reconciliation.read.list',
    GET: 'payment-reconciliation.read.get',
    CREATE: 'payment-reconciliation.write.create',
    UPDATE: 'payment-reconciliation.write.update',
    DOWNLOAD: 'payment-reconciliation.write.download',
    EMAIL: 'payment-reconciliation.write.email'
  },

  // Prescription
  PRESCRIPTION: {
    NAME: 'Prescription',
    ALL: 'prescription',
    SCREEN: 'prescription.read.screen',
    LIST: 'prescription.read.list',
    GET: 'prescription.read.get',
    CREATE: 'prescription.write.create',
    UPDATE: 'prescription.write.update',
    DELETE: 'prescription.write.delete',
    ADJUDICATION: 'prescription.write.adjudication',
    ASSIGNMENT: 'prescription.write.assignment',
    COMMUNICATION: 'prescription.write.communication',
    PBM_CREATE: 'prescription.write.pbm-create',
    PBM_CANCEL: 'prescription.write.pbm-cancel',
    PBM_INQUIRY: 'prescription.write.pbm-inquiry',
    PBM_OVERRIDE: 'prescription.write.pbm-override'
  },

  //Pharmaceutical-Form
  PHARMACEUTICAL_FORM: {
    NAME: 'PharmaceuticalForm',
    ALL: 'pharmaceutical-form',
    SCREEN: 'pharmaceutical-form.read.screen',
    LIST: 'pharmaceutical-form.read.list',
    GET: 'pharmaceutical-form.read.get',
    CREATE: 'pharmaceutical-form.write.create',
    UPDATE: 'pharmaceutical-form.write.update',
    DOWNLOAD: 'pharmaceutical-form.write.download',
    EMAIL: 'pharmaceutical-form.write.email'
  },

  //Dosage Type
  DOSAGE_TYPE: {
    NAME: 'DosageType',
    ALL: 'dosage-type',
    SCREEN: 'dosage-type.read.screen',
    LIST: 'dosage-type.read.list',
    GET: 'dosage-type.read.get',
    CREATE: 'dosage-type.write.create',
    UPDATE: 'dosage-type.write.update',
    DOWNLOAD: 'dosage-type.write.download',
    EMAIL: 'dosage-type.write.email'
  },

  // UCUM Code
  UCUM_CODE: {
    NAME: 'UcumCode',
    ALL: 'ucum-code',
    SCREEN: 'ucum-code.read.screen',
    LIST: 'ucum-code.read.list',
    GET: 'ucum-code.read.get',
    CREATE: 'ucum-code.write.create',
    UPDATE: 'ucum-code.write.update',
    DELETE: 'ucum-code.write.delete',
  },

  //Claim Reimbursement for patient
  CLAIM_REIMBURSEMENT: {
    NAME: 'ClaimReimbursement',
    ALL: 'claim-reimbursement',
    SCREEN: 'claim-reimbursement.read.screen',
    LIST: 'claim-reimbursement.read.list',
    GET: 'claim-reimbursement.read.get',
    CREATE: 'claim-reimbursement.write.create',
    UPDATE: 'claim-reimbursement.write.update',
    DELETE: 'claim-reimbursement.write.delete',
    ADJUDICATION: 'claim-reimbursement.write.adjudication',
    ASSIGNMENT: 'claim-reimbursement.write.assignment',
    COMMUNICATION: 'claim-reimbursement.write.communication',
    ACTIVATE: 'claim-reimbursement.write.activate',
    DOWNLOAD: 'claim-reimbursement.write.download',
    EMAIL: 'claim-reimbursement.write.email',
    CONVERT: 'claim-reimbursement.write.convert'
  },

  // Provider notifications
  PROVIDER_NOTIFICATION: {
    NAME: 'ProviderNotification',
    ALL: 'provider-notification',
    SCREEN: 'provider-notification.read.screen',
    LIST: 'provider-notification.read.list',
    GET: 'provider-notification.read.get',
    CREATE: 'provider-notification.write.create',
    UPDATE: 'provider-notification.write.update',
  },

  // Payer notifications
  PAYER_NOTIFICATION: {
    NAME: 'PayerNotification',
    ALL: 'payer-notification',
    SCREEN: 'payer-notification.read.screen',
    LIST: 'payer-notification.read.list',
    GET: 'payer-notification.read.get',
    CREATE: 'payer-notification.write.create',
    UPDATE: 'payer-notification.write.update',
  },

  // Patient notifications
  PATIENT_NOTIFICATION: {
    NAME: 'PatientNotification',
    ALL: 'patient-notification',
    SCREEN: 'patient-notification.read.screen',
    LIST: 'patient-notification.read.list',
    GET: 'patient-notification.read.get',
    CREATE: 'patient-notification.write.create',
    UPDATE: 'patient-notification.write.update',
  },

  // Payer and provider setting
  PAYER_PROVIDER_SETTING: {
    NAME: 'PayerProviderSetting',
    ALL: 'payer-provider-setting',
    SCREEN: 'payer-provider-setting.read.screen',
    LIST: 'payer-provider-setting.read.list',
    GET: 'payer-provider-setting.read.get',
    CREATE: 'payer-provider-setting.write.create',
  },

  // Patient user's dashboard
  PATIENT_DASHBOARD: {
    NAME: 'PatientDashboard',
    ALL: 'patient-dashboard',
    SCREEN: 'patient-dashboard.read.screen',
    GET: 'patient-dashboard.read.get',
  },

  // Unit Type
  UNIT_TYPE: {
    NAME: 'UnitType',
    ALL: 'unit-type',
    SCREEN: 'unit-type.read.screen',
    LIST: 'unit-type.read.list',
    GET: 'unit-type.read.get',
    CREATE: 'unit-type.write.create',
    UPDATE: 'unit-type.write.update',
    DELETE: 'unit-type.write.delete',
  },

  // user's activity
  USER_ACTIVITY: {
    NAME: 'UserActivity',
    ALL: 'user-activity',
    CREATE: 'user-activity.write.create',
    LIST: 'user-activity.read.list',
    GET: 'user-activity.read.get',
  },

  // System settings
  SYSTEM_SETTINGS: {
    NAME: 'SystemSetting',
    ALL: 'system-setting',
    SCREEN: 'system-setting.read.screen',
    LIST: 'system-setting.read.list',
    GET: 'system-setting.read.get',
    CREATE: 'system-setting.write.create',
    UPDATE: 'system-setting.write.update',
    DELETE: 'system-setting.write.delete'
  },

  // User settings
  USER_SETTINGS: {
    NAME: 'UserSetting',
    ALL: 'user-setting',
    LIST: 'user-setting.read.list',
    GET: 'user-setting.read.get',
    CREATE: 'user-setting.write.create',
    DELETE: 'user-setting.write.delete'
  },

  PAYER_SETTINGS: {
    NAME: 'PayerSetting',
    ALL: 'payer-setting',
    LIST: 'payer-setting.read.list',
    CREATE: 'payer-setting.write.create',
  },

  // Chart settings
  CHART_SETTINGS: {
    NAME: 'ChartSetting',
    ALL: 'chart-setting',
    LIST: 'chart-setting.read.list',
    GET: 'chart-setting.read.get',
    SCREEN: 'chart-setting.read.screen',
    CREATE: 'chart-setting.write.create',
    UPDATE: 'chart-setting.write.update',
    DELETE: 'chart-setting.write.delete'
  },

  // User chart settings
  USER_CHART_SETTINGS: {
    NAME: 'UserChartSetting',
    ALL: 'user-chart-setting',
    LIST: 'user-chart-setting.read.list',
    CREATE: 'user-chart-setting.write.create',
  },

  // Nphies Json
  NPHIES_JSON: {
    NAME: 'NphiesJson',
    ALL: 'nphies-json',
    GET: 'nphies-json.read.get'
  },

  // Reports
  REPORTS: {
    NAME: 'Report',
    ALL: 'report',
    SCREEN: 'report.read.screen',
    GET: 'report.read.get'
  }
};

export const DEFAULT_PERMISSIONS_FOR_ROLE = [
  PERMISSION.BENEFICIARY.GET, PERMISSION.BENEFICIARY.LIST,
  PERMISSION.BENEFIT.GET, PERMISSION.BENEFIT.LIST,
  PERMISSION.BODY_SITE.GET, PERMISSION.BODY_SITE.LIST,
  PERMISSION.BODY_SUB_SITE.GET, PERMISSION.BODY_SUB_SITE.LIST,
  PERMISSION.CATEGORY.GET, PERMISSION.CATEGORY.LIST,
  PERMISSION.CITY.GET, PERMISSION.CITY.LIST,
  PERMISSION.CLAIM_TYPE.GET, PERMISSION.CLAIM_TYPE.LIST,
  PERMISSION.COMMON_LOV.GET, PERMISSION.COMMON_LOV.LIST,
  PERMISSION.CONTRACT.GET, PERMISSION.CONTRACT.LIST,
  PERMISSION.COUNTRY.GET, PERMISSION.COUNTRY.LIST,
  PERMISSION.DASHBOARD.GET, PERMISSION.DASHBOARD.SCREEN,
  PERMISSION.DIAGNOSIS_CODE.GET, PERMISSION.DIAGNOSIS_CODE.LIST,
  PERMISSION.DOSAGE_TYPE.GET, PERMISSION.DOSAGE_TYPE.LIST,
  PERMISSION.ENCOUNTER_CLASS.GET, PERMISSION.ENCOUNTER_CLASS.LIST,
  PERMISSION.INSURANCE_COMPANY.GET, PERMISSION.INSURANCE_COMPANY.LIST,
  PERMISSION.LOINC_CODE.GET, PERMISSION.LOINC_CODE.LIST,
  PERMISSION.MASTER_DATA.GET, PERMISSION.MASTER_DATA.JSON, PERMISSION.MASTER_DATA.LIST,
  PERMISSION.MORPHOLOGY.GET, PERMISSION.MORPHOLOGY.LIST,
  PERMISSION.NETWORK.GET, PERMISSION.NETWORK.LIST,
  PERMISSION.PHARMACEUTICAL_FORM.GET, PERMISSION.PHARMACEUTICAL_FORM.LIST,
  PERMISSION.PHYSICIAN.GET, PERMISSION.PHYSICIAN.LIST,
  PERMISSION.POLICY.GET, PERMISSION.POLICY.LIST,
  PERMISSION.POLICY_CLASS.GET, PERMISSION.POLICY_CLASS.LIST,
  PERMISSION.PRICE_LIST.GET, PERMISSION.PRICE_LIST.LIST,
  PERMISSION.PROVIDER.GET, PERMISSION.PROVIDER.LIST,
  PERMISSION.REASON.GET, PERMISSION.REASON.LIST,
  PERMISSION.ROLE.GET,
  PERMISSION.SERVICE_CODE.GET, PERMISSION.SERVICE_CODE.LIST,
  PERMISSION.SERVICE_TYPE.GET, PERMISSION.SERVICE_TYPE.LIST,
  PERMISSION.SPECIALITY.GET, PERMISSION.SPECIALITY.LIST,
  PERMISSION.STATE.GET, PERMISSION.STATE.LIST,
  PERMISSION.UCUM_CODE.GET, PERMISSION.UCUM_CODE.LIST,
  PERMISSION.UNIT_TYPE.GET, PERMISSION.UNIT_TYPE.LIST,
  PERMISSION.USER.GET, PERMISSION.USER.LIST,
  PERMISSION.USER_ACTIVITY.GET, PERMISSION.USER_ACTIVITY.LIST,
  PERMISSION.SYSTEM_SETTINGS.GET, PERMISSION.SYSTEM_SETTINGS.LIST, PERMISSION.SYSTEM_SETTINGS.SCREEN,
  PERMISSION.USER_SETTINGS.GET, PERMISSION.USER_SETTINGS.LIST, PERMISSION.USER_SETTINGS.CREATE, PERMISSION.USER_SETTINGS.DELETE,
  PERMISSION.CHART_SETTINGS.GET, PERMISSION.CHART_SETTINGS.LIST,
  PERMISSION.USER_CHART_SETTINGS.LIST, PERMISSION.USER_CHART_SETTINGS.CREATE,
  PERMISSION.PAYER_SETTINGS.LIST
];

//ts-prune-ignore-next
export const PAYER_PERMISSION = {

  //Audit Log
  AUDIT_LOG: {
    LIST: 'audit-log.read.list',
    GET: 'audit-log.read.get',
  },

  // Beneficiary
  BENEFICIARY: {
    SCREEN: 'beneficiary.read.screen',
    LIST: 'beneficiary.read.list',
    GET: 'beneficiary.read.get',
  },

  // Benefit
  BENEFIT: {
    SCREEN: 'benefit.read.screen',
    LIST: 'benefit.read.list',
    GET: 'benefit.read.get',
  },

  // Body Site
  BODY_SITE: {
    LIST: 'body-site.read.list',
    GET: 'body-site.read.get',
  },

  // Body Sub Site
  BODY_SUB_SITE: {
    LIST: 'body-sub-site.read.list',
    GET: 'body-sub-site.read.get',
  },

  //Category
  CATEGORY: {
    LIST: 'category.read.list',
    GET: 'category.read.get',
  },

  //City
  CITY: {
    LIST: 'city.read.list',
    GET: 'city.read.get',
  },

  //Claim Reimbursement
  CLAIM_REIMBURSEMENT: {
    SCREEN: 'claim-reimbursement.read.screen',
    LIST: 'claim-reimbursement.read.list',
    GET: 'claim-reimbursement.read.get',
    UPDATE: 'claim-reimbursement.write.update',
    CONVERT: 'claim-reimbursement.write.convert'
  },

  // Claim Type
  CLAIM_TYPE: {
    LIST: 'claim-type.read.list',
    GET: 'claim-type.read.get',
  },

  //Claim
  CLAIM: {
    SCREEN: 'claim.read.screen',
    LIST: 'claim.read.list',
    GET: 'claim.read.get',
    CREATE: 'claim.write.create',
    DOWNLOAD: 'claim.write.download',
    EMAIL: 'claim.write.email',
    ADJUDICATION: 'claim.write.adjudication',
    ASSIGNMENT: 'claim.write.assignment',
    COMMUNICATION: 'claim.write.communication',
    ACTIVATE: 'claim.write.activate',
  },

  // Common LOV
  COMMON_LOV: {
    LIST: 'common-lov.read.list',
    GET: 'common-lov.read.get',
  },

  // Contract
  CONTRACT: {
    SCREEN: 'contract.read.screen',
    LIST: 'contract.read.list',
    GET: 'contract.read.get',
  },

  //Country
  COUNTRY: {
    LIST: 'country.read.list',
    GET: 'country.read.get',
  },

  // Dashboard
  DASHBOARD: {
    ALL: 'dashboard',
    SCREEN: 'dashboard.read.screen',
    GET: 'dashboard.read.get',
  },

  //Denial
  DENIAL: {
    ALL: 'denial',
    SCREEN: 'denial.read.screen',
    LIST: 'denial.read.list',
    GET: 'denial.read.get',
    UPDATE: 'denial.write.update',
  },

  // Diagnosis Code
  DIAGNOSIS_CODE: {
    LIST: 'diagnosis-code.read.list',
    GET: 'diagnosis-code.read.get',
  },

  //Dosage Type
  DOSAGE_TYPE: {
    LIST: 'dosage-type.read.list',
    GET: 'dosage-type.read.get',
  },

  // Drug Code
  DRUG_CODE: {
    LIST: 'drug-code.read.list',
    GET: 'drug-code.read.get',
  },

  //Eligibility
  ELIGIBILITY: {
    ALL: 'eligibility',
    SCREEN: 'eligibility.read.screen',
    LIST: 'eligibility.read.list',
    GET: 'eligibility.read.get',
    CREATE: 'eligibility.write.create',
    DOWNLOAD: 'eligibility.write.download',
    EMAIL: 'eligibility.write.email',
  },

  //Encounter
  ENCOUNTER_CLASS: {
    LIST: 'encounter-class.read.list',
    GET: 'encounter-class.read.get',
  },

  // Insurance Company
  INSURANCE_COMPANY: {
    LIST: 'insurance-company.read.list',
    GET: 'insurance-company.read.get',
  },

  // LOINC Code
  LOINC_CODE: {
    LIST: 'loinc-code.read.list',
    GET: 'loinc-code.read.get',
  },

  // Master Data
  MASTER_DATA: {
    LIST: 'master-data.read.list',
    GET: 'master-data.read.get',
    JSONFILE: 'master-data.write.jsonfile',
  },

  // Medical Device
  MEDICAL_DEVICE: {
    LIST: 'medical-device.read.list',
    GET: 'medical-device.read.get',
  },

  //Morphology
  MORPHOLOGY: {
    LIST: 'morphology.read.list',
    GET: 'morphology.read.get',
  },

  // Network
  NETWORK: {
    SCREEN: 'network.read.screen',
    LIST: 'network.read.list',
    GET: 'network.read.get',
  },

  //Payment-Reconciliation
  PAYMENT_RECONCILIATION: {
    ALL: 'payment-reconciliation',
    SCREEN: 'payment-reconciliation.read.screen',
    LIST: 'payment-reconciliation.read.list',
    GET: 'payment-reconciliation.read.get',
    CREATE: 'payment-reconciliation.write.create',
    UPDATE: 'payment-reconciliation.write.update',
    DOWNLOAD: 'payment-reconciliation.write.download',
    EMAIL: 'payment-reconciliation.write.email'
  },

  //Payment
  PAYMENT: {
    ALL: 'payment',
    SCREEN: 'payment.read.screen',
    LIST: 'payment.read.list',
    GET: 'payment.read.get',
    CREATE: 'payment.write.create',
    UPDATE: 'payment.write.update',
    DELETE: 'payment.write.delete',
    DOWNLOAD: 'payment.write.download',
    EMAIL: 'payment.write.email'
  },

  // Permission
  PERMISSION: {
    LIST: 'permission.read.list',
    GET: 'permission.read.get',
  },
  //Pharmaceutical-Form
  PHARMACEUTICAL_FORM: {
    LIST: 'pharmaceutical-form.read.list',
    GET: 'pharmaceutical-form.read.get',
  },

  // Physician
  PHYSICIAN: {
    LIST: 'physician.read.list',
    GET: 'physician.read.get',
  },

  // Policy Class
  POLICY_CLASS: {
    SCREEN: 'policy-class.read.screen',
    LIST: 'policy-class.read.list',
    GET: 'policy-class.read.get',
  },

  // Policy
  POLICY: {
    SCREEN: 'policy.read.screen',
    LIST: 'policy.read.list',
    GET: 'policy.read.get',
  },

  //Pre Auth approval
  PRE_AUTH: {
    SCREEN: 'pre-auth.read.screen',
    LIST: 'pre-auth.read.list',
    GET: 'pre-auth.read.get',
    CREATE: 'pre-auth.write.create',
    UPDATE: 'pre-auth.write.update',
    DOWNLOAD: 'pre-auth.write.download',
    EMAIL: 'pre-auth.write.email',
    ADJUDICATION: 'pre-auth.write.adjudication',
    ASSIGNMENT: 'pre-auth.write.assignment',
    COMMUNICATION: 'pre-auth.write.communication',
    HIGHCOST_ADJUDICATION: 'pre-auth.write.highcost-adjudication'
  },

  // Prescription
  PRESCRIPTION: {
    SCREEN: 'prescription.read.screen',
    LIST: 'prescription.read.list',
    GET: 'prescription.read.get',
    UPDATE: 'prescription.write.update',
    DOWNLOAD: 'prescription.write.download',
    EMAIL: 'prescription.write.email',
    ADJUDICATION: 'prescription.write.adjudication',
    ASSIGNMENT: 'prescription.write.assignment',
    COMMUNICATION: 'prescription.write.communication',
  },

  // Price List
  PRICE_LIST: {
    SCREEN: 'pricelist.read.screen',
    LIST: 'pricelist.read.list',
    GET: 'pricelist.read.get',
  },

  // Provider
  PROVIDER: {
    SCREEN: 'provider.read.screen',
    LIST: 'provider.read.list',
    GET: 'provider.read.get',
    DOWNLOAD: 'provider.write.download'
  },

  // Reason
  REASON: {
    LIST: 'reason.read.list',
    GET: 'reason.read.get',
  },

  // Role
  ROLE: {
    LIST: 'role.read.list',
    GET: 'role.read.get',
  },

  // Service Code
  SERVICE_CODE: {
    LIST: 'service-code.read.list',
    GET: 'service-code.read.get',
  },

  // Service Type
  SERVICE_TYPE: {
    LIST: 'service-type.read.list',
    GET: 'service-type.read.get',
  },

  // Speciality
  SPECIALITY: {
    LIST: 'speciality.read.list',
    GET: 'speciality.read.get',
  },

  //State
  STATE: {
    LIST: 'state.read.list',
    GET: 'state.read.get',
  },

  //Sub Coverage
  SUB_COVERAGE: {
    LIST: 'sub-coverage.read.list',
    GET: 'sub-coverage.read.get',
  },

  //Supporting Info Type
  SUPPORTING_INFO_TYPE: {
    LIST: 'supporting-info-type.read.list',
    GET: 'supporting-info-type.read.get',
  },

  // UCUM Code
  UCUM_CODE: {
    LIST: 'ucum-code.read.list',
    GET: 'ucum-code.read.get',
  },

  // Unit type
  UNIT_TYPE: {
    LIST: 'unit-type.read.list',
    GET: 'unit-type.read.get',
  },

  // User Activity
  USER_ACTIVITY: {
    LIST: 'user-activity.read.list',
    GET: 'user-activity.read.get',
  },

  // User
  USER: {
    LIST: 'user.read.list',
    GET: 'user.read.get',
    UPDATE: 'user.write.update',
  }
};

//ts-prune-ignore-next
export const PATIENT_PERMISSION = {
  // Beneficiary
  BENEFICIARY: {
    LIST: 'beneficiary.read.list',
    GET: 'beneficiary.read.get',
  },

  //City
  CITY: {
    LIST: 'city.read.list',
    GET: 'city.read.get',
  },

  //Claim Reimbursement
  CLAIM_REIMBURSEMENT: {
    SCREEN: 'claim-reimbursement.read.screen',
    LIST: 'claim-reimbursement.read.list',
    GET: 'claim-reimbursement.read.get',
    CREATE: 'claim-reimbursement.write.create',
    UPDATE: 'claim-reimbursement.write.update',
    DOWNLOAD: 'claim-reimbursement.write.download',
    EMAIL: 'claim-reimbursement.write.email',
  },

  // Claim Type
  CLAIM_TYPE: {
    LIST: 'claim-type.read.list',
    GET: 'claim-type.read.get',
  },

  //Claim
  CLAIM: {
    SCREEN: 'claim.read.screen',
    LIST: 'claim.read.list',
    GET: 'claim.read.get',
    DOWNLOAD: 'claim.write.download',
    EMAIL: 'claim.write.email',
  },

  // Common LOV
  COMMON_LOV: {
    LIST: 'common-lov.read.list',
    GET: 'common-lov.read.get',
  },

  //Country
  COUNTRY: {
    LIST: 'country.read.list',
    GET: 'country.read.get',
  },

  // Dashboard
  DASHBOARD: {
    ALL: 'dashboard',
    SCREEN: 'dashboard.read.screen',
    GET: 'dashboard.read.get',
  },

  //Faq's
  FAQ: {
    SCREEN: 'faq.read.screen',
    LIST: 'faq.read.list',
    GET: 'faq.read.get',
  },

  // Master Data
  MASTER_DATA: {
    LIST: 'master-data.read.list',
    GET: 'master-data.read.get',
    JSONFILE: 'master-data.write.jsonfile',
  },

  // Patient user's dashboard
  PATIENT_DASHBOARD: {
    ALL: 'patient-dashboard',
    SCREEN: 'patient-dashboard.read.screen',
    GET: 'patient-dashboard.read.get',
  },

  // Patient notifications
  NOTIFICATION: {
    SCREEN: 'patient-notification.read.screen',
    LIST: 'patient-notification.read.list',
    GET: 'patient-notification.read.get',
    UPDATE: 'patient-notification.write.update',
  },

  // Permission
  PERMISSION: {
    LIST: 'permission.read.list',
    GET: 'permission.read.get',
  },

  // Policy Class
  POLICY_CLASS: {
    LIST: 'policy-class.read.list',
    GET: 'policy-class.read.get',
  },

  // Policy
  POLICY: {
    SCREEN: 'policy.read.screen',
    LIST: 'policy.read.list',
    GET: 'policy.read.get',
    DOWNLOAD: 'policy.write.download',
    EMAIL: 'policy.write.email',
  },

  //Pre Auth approval
  PRE_AUTH: {
    SCREEN: 'pre-auth.read.screen',
    LIST: 'pre-auth.read.list',
    GET: 'pre-auth.read.get',
    DOWNLOAD: 'pre-auth.write.download',
    EMAIL: 'pre-auth.write.email',
  },

  // Prescription
  PRESCRIPTION: {
    SCREEN: 'prescription.read.screen',
    LIST: 'prescription.read.list',
    GET: 'prescription.read.get',
    DOWNLOAD: 'prescription.write.download',
    EMAIL: 'prescription.write.email',
  },

  // Provider
  PROVIDER: {
    LIST: 'provider.read.list',
    GET: 'provider.read.get',
  },

  // Reason
  REASON: {
    LIST: 'reason.read.list',
  },

  // Role
  ROLE: {
    LIST: 'role.read.list',
    GET: 'role.read.get',
  },

  //State
  STATE: {
    LIST: 'state.read.list',
    GET: 'state.read.get',
  },

  // User Activity
  USER_ACTIVITY: {
    LIST: 'user-activity.read.list',
    GET: 'user-activity.read.get',
  },

  // User
  USER: {
    LIST: 'user.read.list',
    GET: 'user.read.get',
    UPDATE: 'user.write.update',
  }
};

//ts-prune-ignore-next
export const PROVIDER_PERMISSION = {
  // Beneficiary
  BENEFICIARY: {
    LIST: 'beneficiary.read.list',
    GET: 'beneficiary.read.get',
    SCREEN: 'beneficiary.read.screen',
  },

  // Benefit
  BENEFIT: {
    LIST: 'benefit.read.list',
    GET: 'benefit.read.get',
  },

  // Body Site
  BODY_SITE: {
    LIST: 'body-site.read.list',
    GET: 'body-site.read.get',
  },

  // Body Sub Site
  BODY_SUB_SITE: {
    LIST: 'body-sub-site.read.list',
    GET: 'body-sub-site.read.get',
  },

  //Category
  CATEGORY: {
    LIST: 'category.read.list',
    GET: 'category.read.get',
  },

  //City
  CITY: {
    LIST: 'city.read.list',
    GET: 'city.read.get',
  },

  //Claim
  CLAIM_CONVERT: {
    ALL: 'claim-convert',
    SCREEN: 'claim-convert.read.screen',
    LIST: 'claim-convert.read.list',
    GET: 'claim-convert.read.get',
    CREATE: 'claim-convert.write.create',
    UPDATE: 'claim-convert.write.update'
  },

  // Claim Type
  CLAIM_TYPE: {
    LIST: 'claim-type.read.list',
    GET: 'claim-type.read.get',
  },

  // Claim Upload History
  CLAIM_UPLOAD_HISTORY: {
    ALL: 'claim-upload-history',
    LIST: 'claim-upload-history.read.list',
    GET: 'claim-upload-history.read.get',
    SCREEN: 'claim-upload-history.read.screen',
  },

  // Claim Upload
  CLAIM_UPLOAD: {
    ALL: 'claim-upload',
    LIST: 'claim-upload.read.list',
    GET: 'claim-upload.read.get',
    SCREEN: 'claim-upload.read.screen',
    DELETE: 'claim-upload.write.delete',
  },

  //Claim
  CLAIM: {
    SCREEN: 'claim.read.screen',
    LIST: 'claim.read.list',
    GET: 'claim.read.get',
    CREATE: 'claim.write.create',
    UPDATE: 'claim.write.update',
    DELETE: 'claim.write.delete',
    DOWNLOAD: 'claim.write.download',
    EMAIL: 'claim.write.email',
    ACTIVATE: 'claim.write.activate',
    COMMUNICATION: 'claim.write.communication',
  },

  // Common LOV
  COMMON_LOV: {
    LIST: 'common-lov.read.list',
    GET: 'common-lov.read.get',
  },

  // Contract
  CONTRACT: {
    SCREEN: 'contract.read.screen',
    LIST: 'contract.read.list',
    GET: 'contract.read.get',
  },

  //Country
  COUNTRY: {
    LIST: 'country.read.list',
    GET: 'country.read.get',
  },

  // Dashboard
  DASHBOARD: {
    ALL: 'dashboard',
    SCREEN: 'dashboard.read.screen',
    GET: 'dashboard.read.get',
  },

  //Denial
  DENIAL: {
    ALL: 'denial',
    SCREEN: 'denial.read.screen',
    LIST: 'denial.read.list',
    GET: 'denial.read.get',
    UPDATE: 'denial.write.update',
  },

  // Diagnosis Code
  DIAGNOSIS_CODE: {
    LIST: 'diagnosis-code.read.list',
    GET: 'diagnosis-code.read.get',
  },

  //Dosage Type
  DOSAGE_TYPE: {
    LIST: 'dosage-type.read.list',
    GET: 'dosage-type.read.get',
  },

  // Drug Code
  DRUG_CODE: {
    LIST: 'drug-code.read.list',
    GET: 'drug-code.read.get',
  },

  //Eligibility
  ELIGIBILITY: {
    ALL: 'eligibility',
    SCREEN: 'eligibility.read.screen',
    LIST: 'eligibility.read.list',
    GET: 'eligibility.read.get',
    CREATE: 'eligibility.write.create',
    DOWNLOAD: 'eligibility.write.download',
    EMAIL: 'eligibility.write.email',
  },

  //Encounter
  ENCOUNTER_CLASS: {
    LIST: 'encounter-class.read.list',
    GET: 'encounter-class.read.get',
  },

  // Insurance Company
  INSURANCE_COMPANY: {
    LIST: 'insurance-company.read.list',
    GET: 'insurance-company.read.get',
  },

  // LOINC Code
  LOINC_CODE: {
    LIST: 'loinc-code.read.list',
    GET: 'loinc-code.read.get',
  },

  // Master Data
  MASTER_DATA: {
    LIST: 'master-data.read.list',
    GET: 'master-data.read.get',
    JSONFILE: 'master-data.write.jsonfile',
  },

  // Medical Device
  MEDICAL_DEVICE: {
    LIST: 'medical-device.read.list',
    GET: 'medical-device.read.get',
  },

  //Morphology
  MORPHOLOGY: {
    LIST: 'morphology.read.list',
    GET: 'morphology.read.get',
  },

  // Network
  NETWORK: {
    LIST: 'network.read.list',
    GET: 'network.read.get',
  },

  //Payment-Reconciliation
  PAYMENT_RECONCILIATION: {
    SCREEN: 'payment-reconciliation.read.screen',
    LIST: 'payment-reconciliation.read.list',
    GET: 'payment-reconciliation.read.get',
    UPDATE: 'payment-reconciliation.write.update',
    DOWNLOAD: 'payment-reconciliation.write.download',
    EMAIL: 'payment-reconciliation.write.email'
  },

  //Payment
  PAYMENT: {
    SCREEN: 'payment.read.screen',
    LIST: 'payment.read.list',
    GET: 'payment.read.get',
    UPDATE: 'payment.write.update',
    DOWNLOAD: 'payment.write.download',
    EMAIL: 'payment.write.email'
  },

  // Permission
  PERMISSION: {
    LIST: 'permission.read.list',
    GET: 'permission.read.get',
  },


  //Pharmaceutical-Form
  PHARMACEUTICAL_FORM: {
    LIST: 'pharmaceutical-form.read.list',
    GET: 'pharmaceutical-form.read.get',
  },

  // Physician
  PHYSICIAN: {
    LIST: 'physician.read.list',
    GET: 'physician.read.get',
  },

  // Policy Class
  POLICY_CLASS: {
    LIST: 'policy-class.read.list',
    GET: 'policy-class.read.get',
  },

  // Policy
  POLICY: {
    LIST: 'policy.read.list',
    GET: 'policy.read.get',
  },

  //Pre Auth approval
  PRE_AUTH: {
    SCREEN: 'pre-auth.read.screen',
    LIST: 'pre-auth.read.list',
    GET: 'pre-auth.read.get',
    CREATE: 'pre-auth.write.create',
    UPDATE: 'pre-auth.write.update',
    DELETE: 'pre-auth.write.delete',
    DOWNLOAD: 'pre-auth.write.download',
    EMAIL: 'pre-auth.write.email',
    COMMUNICATION: 'pre-auth.write.communication',
  },

  // Prescription
  PRESCRIPTION: {
    SCREEN: 'prescription.read.screen',
    LIST: 'prescription.read.list',
    GET: 'prescription.read.get',
    CREATE: 'prescription.write.create',
    UPDATE: 'prescription.write.update',
    DELETE: 'prescription.write.delete',
    DOWNLOAD: 'prescription.write.download',
    EMAIL: 'prescription.write.email',
    COMMUNICATION: 'prescription.write.communication',
  },

  // Price List
  PRICE_LIST: {
    LIST: 'pricelist.read.list',
    GET: 'pricelist.read.get',
  },

  // Provider
  PROVIDER: {
    ALL: 'provider',
    SCREEN: 'provider.read.screen',
    LIST: 'provider.read.list',
    GET: 'provider.read.get',
    CREATE: 'provider.write.create',
    UPDATE: 'provider.write.update',
    DELETE: 'provider.write.delete',
    DOWNLOAD: 'provider.write.download'
  },

  // Reason
  REASON: {
    LIST: 'reason.read.list',
    GET: 'reason.read.get',
  },

  // Role
  ROLE: {
    LIST: 'role.read.list',
    GET: 'role.read.get',
  },

  // Service Code
  SERVICE_CODE: {
    LIST: 'service-code.read.list',
    GET: 'service-code.read.get',
  },

  // Service Type
  SERVICE_TYPE: {
    LIST: 'service-type.read.list',
    GET: 'service-type.read.get',
  },

  // Speciality
  SPECIALITY: {
    LIST: 'speciality.read.list',
    GET: 'speciality.read.get',
  },

  //State
  STATE: {
    LIST: 'state.read.list',
    GET: 'state.read.get',
  },

  //Sub Coverage
  SUB_COVERAGE: {
    LIST: 'sub-coverage.read.list',
    GET: 'sub-coverage.read.get',
  },

  //Supporting Info Type
  SUPPORTING_INFO_TYPE: {
    LIST: 'supporting-info-type.read.list',
    GET: 'supporting-info-type.read.get',
    CREATE: 'supporting-info-type.write.create',
    UPDATE: 'supporting-info-type.write.update',
    DELETE: 'supporting-info-type.write.delete',
  },

  // UCUM Code
  UCUM_CODE: {
    LIST: 'ucum-code.read.list',
    GET: 'ucum-code.read.get',
  },

  // Unit type
  UNIT_TYPE: {
    LIST: 'unit-type.read.list',
    GET: 'unit-type.read.get',
  },

  // User Activity
  USER_ACTIVITY: {
    LIST: 'user-activity.read.list',
    GET: 'user-activity.read.get',
  },

  // User
  USER: {
    LIST: 'user.read.list',
    GET: 'user.read.get',
    UPDATE: 'user.write.update',
  }
};
